import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Chip,
  Button
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import { useNavigate } from 'react-router-dom';
import Navbar from '../navbar/navbar';
import FooterBar from '../footer/footerBar';
import api from '../../services/api';
import { vhostV1 } from '../funcoes';
import SweetAlert from 'react-bootstrap-sweetalert';



export default function ListaMesas() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mesaSelecionada, setMesaSelecionada] = useState(null);
  const [mesas, setMesas] = useState([]);
  const [totalPaginas, setTotalPaginas] = useState(0);
  const [busca, setBusca] = useState('');
  const [nPag, setNPag] = useState(1);
  const [localizacao, setLocalizacao] = useState('');
  const [idInicial, setIdInicial] = useState(0);
  const [idFinal, setIdFinal] = useState(0);
  const [showModalMesa, setShowModalMesa] = useState(false);
  const [showMesaEdit, setShowMesaEdit] = useState(false);
  const [reload, setReload] = useState(false);
  const [msgErro, setMsgErro] = useState('');
  const [erroValidacao, setErroValidacao] = useState(false);
  const [confirmacao, setConfirmacao] = useState(false);
  const [confirmacaoID, setConfirmacaoID] = useState(null);
  const navigate = useNavigate();

   let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  const handleMenuOpen = (event, mesa) => {
    setAnchorEl(event.currentTarget);
    setMesaSelecionada(mesa);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMesaSelecionada(null);
  };

  const handleEditar = (mesa) => {
    setIdInicial(mesa.ID);
    setIdFinal(mesa.ID);
    setLocalizacao(mesa.LOCALIZACAO);
    setShowMesaEdit(true);

    console.log('Editar mesa:', mesaSelecionada);
    handleMenuClose();
  };

  const handleExcluir = () => {
    console.log('Excluir mesa:', mesaSelecionada);
    handleMenuClose();
  };

  function deleteUser(id){
          api.delete(vhostV1('webcash/cadastro/mesas/'+Number(id)),config)
            .then(function (response) {
              console.log(response);
              
              setConfirmacao(false);
              setReload(!reload);
                      
            })
            .catch(function (error) {
              console.log(error);
              setConfirmacao(false);
              
            });
          
        
        }

        function confirmadeleteUser(id){
      
      setConfirmacaoID(id);
      setConfirmacao(true);
      handleMenuClose();
     
      
    }


   useEffect(function(){
  
         api.post(vhostV1('webcash/cadastro/mesas/listar'), {
            loja: localStorage.getItem('loja'),
            empresa: 1,
            pagina: nPag,
            regPag: 20,
            busca: busca
          },config)
          .then(function (response) {
            
            setMesas(response.data.dados);
            setTotalPaginas(response.data.quantidadePagina);
            console.log(response);
            
        
                                                
                     
          })
          .catch(function (error) {
           
            console.log(error);
           
  
                    
          });
    
          
      },[busca,nPag,reload])

      function salvaMesa(e){
        if (!idInicial || !idFinal) {
    setMsgErro('Informe as mesas corretamente')
    setErroValidacao(true);
    return;
  }

  if (Number(idInicial) > Number(idFinal)) {
    setMsgErro('ID inicial não pode ser maior que o final')
    setErroValidacao(true);
    return;
  }

  if (localizacao.length > 10){
    setMsgErro('Localização deve conter no máximo 10 caracteres')
    setErroValidacao(true);
    return;
  }
          e.preventDefault();  
              api.post(vhostV1('webcash/cadastro/mesas/inclui'),{
                  idInicial: Number(idInicial),
                  idFinal: Number(idFinal),
                  LOCALIZACAO:localizacao         

                  
                },config)
              .then(function(response){
                  if (response.data.result === 1) {
                    setReload(!reload);
                    setShowModalMesa(false);
                    setShowMesaEdit(false);
                  }
                  
                  console.log(response)
              }).catch((erro) =>{
                  console.log(erro);
                  
              });
           } 

      const formatarDataHora = (data) => {
  if (!data) return '---';

  return new Date(data).toLocaleString('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'medium',
  });
};
  return (
    <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
      <Navbar />

      <div className="container-fluid titulo mt-5 offset-lg-1 col-lg-10" style={{ flex: 1 }}>
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-3 mt-5">
          <Typography variant="h4">
            Cadastro de Mesas
          </Typography>

          <Button
  variant="contained"
  color="primary"
  onClick={() => setShowModalMesa(true)}
>
  + Adicionar Mesa
</Button>
        </div>

        <hr />

        {/* LISTAGEM */}
        <Grid container spacing={3} className="mt-2">
          {mesas.map((mesa) => {
            const ativa = mesa.ATIVA === 'S';

            return (
              <Grid item xs={12} sm={6} md={6} lg={4} key={mesa.ID}>
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    border: ativa ? '2px solid #4caf50' : '2px solid #f44336'
                  }}
                >
                  <CardContent>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <TableRestaurantIcon
                        sx={{
                          fontSize: 40,
                          color: ativa ? '#4caf50' : '#f44336'
                        }}
                      />

                      <IconButton onClick={(e) => handleMenuOpen(e, mesa)}>
                        <MoreVertIcon />
                      </IconButton>
                    </div>

                    <Typography variant="h6">Mesa #{mesa.ID}</Typography>

                    <Typography variant="body2" color="text.secondary">
                      Local: {mesa.LOCALIZACAO}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      Pessoas: {mesa.NRPESSOAS}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      Abertura: {formatarDataHora(mesa.DH_ABERTURA)}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      Fechamento: {formatarDataHora(mesa.DH_FECHAMENTO) || '---'}
                    </Typography>
                    <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={() => handleEditar(mesa)}>Editar</MenuItem>
          <MenuItem onClick={() => confirmadeleteUser(mesa.ID)}>Excluir</MenuItem>
        </Menu>

                    {/* <div className="mt-2">
                      <Chip
                        label={mesa.STATUS}
                        color={mesa.STATUS === 'Aberta' ? 'success' : 'default'}
                        size="small"
                      />
                    </div> */}
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        
      </div>

         {
                    erroValidacao ? 
                    <SweetAlert
                       danger
                       confirmBtnText="OK"
                       confirmBtnBsStyle="danger"
                       title="Erro"
                       onConfirm={() => setErroValidacao(false)}                            
                     >
                       {msgErro}
                     </SweetAlert>:null
                    
                   }

                   {
           confirmacao ? 
           <SweetAlert
              warning
              showCancel
              showCloseButton
              confirmBtnText="Sim"
              confirmBtnBsStyle="danger"
              cancelBtnText="Não"
              cancelBtnBsStyle='ligth'
              title="Atenção"
              onConfirm={() =>deleteUser(confirmacaoID)}
              onCancel={() => setConfirmacao(false)}
              focusCancelBtn
              reverseButtons
            >
              Deseja excluir Esta Mesa?
            </SweetAlert>:null
           
          }

      {showModalMesa && (
  <div className="modal show fade d-block mt-5" tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">

        {/* HEADER */}
        <div className="modal-header">
          <h5 className="modal-title">Adicionar Mesas</h5>
          <button 
            type="button" 
            className="btn-close"
            onClick={() => setShowModalMesa(false)}
          ></button>
        </div>

        {/* BODY */}
        <div className="modal-body">

          <div className="mb-2">
            <label className="form-label">Número Inicial</label>
            <input 
              type="number"
              className="form-control"
              value={idInicial}
              onChange={(e) => setIdInicial(e.target.value)}
              placeholder="Ex: 1"
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Número Final</label>
            <input 
              type="number"
              className="form-control"
              value={idFinal}
              onChange={(e) => setIdFinal(e.target.value)}
              placeholder="Ex: 10"
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Localização</label>
            <input 
              type="text"
              className="form-control"
              value={localizacao}
              onChange={(e) => setLocalizacao(e.target.value)}
              placeholder="Ex: Salão, Varanda..."
            />
          </div>

        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <button 
            className="btn btn-secondary"
            onClick={() => setShowModalMesa(false)}
          >
            Cancelar
          </button>

          <button 
            className="btn btn-primary"
            onClick={salvaMesa}
          >
            Salvar
          </button>
        </div>

      </div>
    </div>
  </div>
)}

{showMesaEdit && (
  <div className="modal show fade d-block mt-5" tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">

        {/* HEADER */}
        <div className="modal-header">
          <h5 className="modal-title">Editar Mesas</h5>
          <button 
            type="button" 
            className="btn-close"
            onClick={() => setShowMesaEdit(false)}
          ></button>
        </div>

        {/* BODY */}
        <div className="modal-body">

          <div className="mb-2">
            <label className="form-label">Número Inicial</label>
            <input 
              type="number"
              className="form-control"
              value={idInicial}
              onChange={(e) => setIdInicial(e.target.value)}
              placeholder="Ex: 1"
              disabled
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Número Final</label>
            <input 
              type="number"
              className="form-control"
              value={idFinal}
              onChange={(e) => setIdFinal(e.target.value)}
              placeholder="Ex: 10"
              disabled
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Localização</label>
            <input 
              type="text"
              className="form-control"
              value={localizacao}
              onChange={(e) => setLocalizacao(e.target.value)}
              placeholder="Ex: Salão, Varanda..."
            />
          </div>

        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <button 
            className="btn btn-secondary"
            onClick={() => setShowMesaEdit(false)}
          >
            Cancelar
          </button>

          <button 
            className="btn btn-primary"
            onClick={salvaMesa}
          >
            Salvar
          </button>
        </div>

      </div>
    </div>
  </div>
)}
      <FooterBar />
    </div>
  );
}

